/* eslint-disable no-param-reassign */
import React, { useRef, useEffect, useState } from 'react';
import Icon from '3-components/Icon/Icon';

export interface AccordionItemProps {
    accordionHeading: string;
    headerTag?: string;
    showOpen?: boolean;
    children: React.ReactNode;
}

const AccordionItem = ({ accordionHeading, headerTag = 'h5', showOpen = false, children }: AccordionItemProps) => {
    const [isOpen, setIsOpen] = useState(showOpen);
    const content = useRef<HTMLDivElement>(null);
    const contentWrapper = useRef<HTMLDivElement>(null);

    const accordionItemHeadingClick = () => {
        // Slide open the accordion content
        if (content.current && contentWrapper.current) {
            if (isOpen) {
                setIsOpen(false);
                content.current.style.height = `${contentWrapper.current.offsetHeight}px`;
                setTimeout(() => {
                    if (content.current) {
                        content.current.style.height = '0px';
                    }
                }, 10);
            } else {
                setIsOpen(true);
                content.current.style.display = 'block';
                setTimeout(() => {
                    if (content.current) {
                        content.current.style.height = `${contentWrapper.current?.offsetHeight}px`;
                    }
                }, 0);
            }
        }
    };

    const accordionItemContentTransitionEnd = () => {
        if (content.current) {
            if (content.current.offsetHeight > 0) {
                content.current.style.height = 'auto';
            }
            if (content.current.offsetHeight === 0 && isOpen) {
                content.current.style.display = 'none';
            }
        }
    };

    content.current?.addEventListener('transitionend', accordionItemContentTransitionEnd);

    useEffect(() => {
        // // pre set height of open items to enable animation
        if (content?.current && isOpen) {
            const contentHeight = contentWrapper.current?.offsetHeight;
            content.current.style.height = `${contentHeight}px`;
        }
    }, []);

    const classOutput = `accordion-item ${isOpen ? 'is-open' : ''}`;

    const HeaderTag = `${headerTag}`;

    return (
        <div className={classOutput}>
            <div
                className="accordion-heading"
            >
                <HeaderTag>
                    <button type="button" className="accordion-title" onClick={accordionItemHeadingClick}>
                        {accordionHeading}
                        <Icon icon="chevron-down" />
                    </button>
                </HeaderTag>
            </div>
            <div ref={content} data-collapsed={!!isOpen} className="accordion-content">
                <div ref={contentWrapper} className="accordion-content-display">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default AccordionItem;
